<template>
  <div class="rili">
    <div class="header">
      <i class="el-icon-arrow-left" @click="del" />
      <p>
        {{ year }}年<span style="margin-left: 20px">{{ month }}</span>月
      </p>
      <i class="el-icon-arrow-right" @click="add" />
    </div>
    <div class="zongweek">
      <div class="weekrow">
        <div class="onecol"><span class="pspan">批次編輯</span></div>
        <div v-for="(item, i) in weeks" :key="i" class="coltwo">
          <p>{{ item }}</p>
          <div class="xuan">
            <div>
              <p>早</p>
              <el-checkbox
                v-model="zaocheck[i]"
                @change="handleCheckAllChangeone(item, i)"
                disabled
              />
            </div>
            <div>
              <p>午</p>
              <el-checkbox
                v-model="wucheck[i]"
                @change="handleCheckAllChangetwo(item, i)"
                disabled
              />
            </div>
            <div>
              <p>晚</p>
              <el-checkbox
                v-model="wancheck[i]"
                @change="handleCheckAllChangethree(item, i)"
                disabled
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(items, index) in Math.ceil(daysList.length / 7)"
        :key="index"
        class="weekrow"
      >
        <div class="onecol">
          <el-checkbox
            v-model="checkcol[index]"
            disabled
            @change="handleCheckAllChange(items, index)"

          />
        </div>
        <div
          v-for="(item, i) in daysList.slice(index * 7, (index + 1) * 7)"
          :key="i"
          class="coltwo"
          :style="{
            borderRight: i == weeks.length - 1 ? '' : '1px solid #A3A3A3',
          }"
        >
          <p :style="{ color: item.isCurrentMonth ? '#000000' : '#A3A3A3' }">
            {{ item.day }}
          </p>
          <div class="xuan2">
            <div
              :style="{
                cursor:  'no-drop',
                background: orderDaysList.find(
                  (it) =>
                    it.year == item.year &&
                    it.month == item.month &&
                    it.day == item.day
                )
                  ? orderDaysList.find(
                    (it) =>
                      it.year == item.year &&
                      it.month == item.month &&
                      it.day == item.day
                  ).breakfast == 1
                    ? '#DBBD80'
                    : ''
                  : '',
                color: orderDaysList.find(
                  (it) =>
                    it.year == item.year &&
                    it.month == item.month &&
                    it.day == item.day
                )
                  ? orderDaysList.find(
                    (it) =>
                      it.year == item.year &&
                      it.month == item.month &&
                      it.day == item.day
                  ).breakfast == 1
                    ? '#FFFFFF'
                    : '#A3A3A3'
                  : '#A3A3A3',
              }"
            >
              <p>早</p>
            </div>
            <div
              :style="{
                cursor:  'no-drop',
                background: orderDaysList.find(
                  (it) =>
                    it.year == item.year &&
                    it.month == item.month &&
                    it.day == item.day
                )
                  ? orderDaysList.find(
                    (it) =>
                      it.year == item.year &&
                      it.month == item.month &&
                      it.day == item.day
                  ).lunch == 1
                    ? '#DBBD80'
                    : ''
                  : '',
                color: orderDaysList.find(
                  (it) =>
                    it.year == item.year &&
                    it.month == item.month &&
                    it.day == item.day
                )
                  ? orderDaysList.find(
                    (it) =>
                      it.year == item.year &&
                      it.month == item.month &&
                      it.day == item.day
                  ).lunch == 1
                    ? '#FFFFFF'
                    : '#A3A3A3'
                  : '#A3A3A3',
              }"
            >
              <p>午</p>
            </div>
            <div
              :style="{
                cursor:  'no-drop',
                background: orderDaysList.find(
                  (it) =>
                    it.year == item.year &&
                    it.month == item.month &&
                    it.day == item.day
                )
                  ? orderDaysList.find(
                    (it) =>
                      it.year == item.year &&
                      it.month == item.month &&
                      it.day == item.day
                  ).dinner == 1
                    ? '#DBBD80'
                    : ''
                  : '',
                color: orderDaysList.find(
                  (it) =>
                    it.year == item.year &&
                    it.month == item.month &&
                    it.day == item.day
                )
                  ? orderDaysList.find(
                    (it) =>
                      it.year == item.year &&
                      it.month == item.month &&
                      it.day == item.day
                  ).dinner == 1
                    ? '#FFFFFF'
                    : '#A3A3A3'
                  : '#A3A3A3',
              }"

            >
              <p>晚</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getRangeDate } from '@/utils/index'

export default {
  model: {
    prop: 'orderDaysList',
    event: 'change'
  },
  props: {
    orderDaysList: {
      type: Array,
      default: () => []
    },
    starttime: {
      type: String,
      default: new Date()
    }
  },
  data() {
    return {
      weeks: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ],
      daysList: [],
      year: null,
      month: null,
      checkAllone: {},
      checkAlltwo: {},
      checkAllthree: {},
      checkAll: {},
      checkedList: [],
      zaocheck: [],
      wucheck: [],
      wancheck: []
    }
  },
  mounted() {
    this.year = Number(this.starttime.slice(0, 4))
    this.month = Number(this.starttime.slice(5, 7))
    this.getdate()
  },
  methods: {
    // 獲取日曆展示的基本數據
    getdate() {
      this.daysList = getRangeDate(this.year, this.month, this.orderDaysList)
      const days = this.daysList.filter((item) => item.isCurrentMonth == true)
      if (!this.checkAllone[days[0].year + '-' + days[0].month]) {
        this.checkAllone[days[0].year + '-' + days[0].month] = [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ]
      }
      if (!this.checkAlltwo[days[0].year + '-' + days[0].month]) {
        this.checkAlltwo[days[0].year + '-' + days[0].month] = [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ]
      }
      if (!this.checkAllthree[days[0].year + '-' + days[0].month]) {
        this.checkAllthree[days[0].year + '-' + days[0].month] = [
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ]
      }
      if (days.length && !this.checkAll[days[0].year + '-' + days[0].month]) {
        const num = this.getWeeks(this.year, this.month)
        const arr = []
        for (let i = 0; i < num; i++) {
          arr.push(false)
        }

        this.checkAll[days[0].year + '-' + days[0].month] = arr
      }
      this.zaocheck = this.checkAllone[this.year + '-' + this.month]
      this.wucheck = this.checkAlltwo[this.year + '-' + this.month]
      this.wancheck = this.checkAllthree[this.year + '-' + this.month]
      this.checkcol = this.checkAll[this.year + '-' + this.month]
      days.forEach((item) => {
        const date =
          item.year +
          '-' +
          (item.month < 10 ? '0' + item.month : item.month) +
          '-' +
          (item.day < 10 ? '0' + item.day : item.day)
        const obj = {
          year: item.year,
          month: item.month,
          day: item.day,
          date: date,
          breakfast: 0,
          lunch: 0,
          dinner: 0,
          week: new Date(date).getDay(),
          zhou:
            new Date(date).getDay() == 0
              ? this.getMonthWeek(date) + 1
              : this.getMonthWeek(date)
        }
        if (
          this.orderDaysList.filter((it) => {
            return it.year == item.year
          }).length <= 0
        ) {
          this.orderDaysList.push(obj)
        } else if (
          this.orderDaysList.filter((it) => {
            return it.year == item.year && it.month == item.month
          }).length <= 0
        ) {
          this.orderDaysList.push(obj)
        } else if (
          this.orderDaysList.filter((it) => {
            return (
              it.year == item.year &&
              it.month == item.month &&
              it.day == item.day
            )
          }).length <= 0
        ) {
          this.orderDaysList.push(obj)
        }
      })

      const arr = {}
      this.orderDaysList.forEach((item) => {
        if (!arr[item.week]) {
          arr[item.week] = []
          arr[item.week].push(item.zhou)
        } else {
          arr[item.week].push(item.zhou)
        }
      })
      this.checkedList = arr
    },

    // 根據日期判斷第幾周
    getMonthWeek(date) {
      const time = new Date(date)
      let w = time.getDay()
      const d = time.getDate()
      if (w == 0) {
        w = 7
      }
      return Math.ceil((d + 6 - w) / 7)
    },

    // 獲取每月有幾周
    getWeeks(year, month) {
      const d = new Date()
      d.setFullYear(year, month - 1, 1)
      let w1 = d.getDay()
      if (w1 == 0) w1 = 7
      d.setFullYear(year, month, 0)
      const dd = d.getDate()
      let d1
      if (w1 != 1) {
        d1 = 7 - w1 + 2
      } else {
        d1 = 1
      }
      const week_count = Math.ceil((dd - d1 + 1) / 7)
      return week_count
    },

    // 下一個月
    add() {
      if (this.month == 12) {
        this.year++
        this.month = 1
      } else {
        this.month++
      }
      this.getdate()
    },
    // 上一個月
    del() {
      if (this.month == 1) {
        this.year--
        this.month = 12
      } else {
        this.month--
      }
      this.getdate()
    },

    // 星期几早餐全選
    handleCheckAllChangeone(val, i) {
      const index = this.weeks.indexOf(val)
      this.orderDaysList = this.orderDaysList.map((item) => {
        if (item.year == this.year && item.month == this.month) {
          if (index == item.week) {
            if (this.checkAllone[this.year + '-' + this.month][i] == true) {
              if (item.dinner != 3) {
                item.breakfast = 1
              }
            } else {
              if (item.dinner != 3) {
                item.breakfast = 0
              }
            }
          }
        }
        return item
      })
      this.checkzou()
      this.$emit('change', this.orderDaysList)
    },

    // 星期几午餐全選
    handleCheckAllChangetwo(val, i) {
      const index = this.weeks.indexOf(val)
      this.orderDaysList = this.orderDaysList.map((item) => {
        if (item.year == this.year && item.month == this.month) {
          if (index == item.week) {
            if (this.checkAlltwo[this.year + '-' + this.month][i] == true) {
              if (item.dinner != 3) {
                item.lunch = 1
              }
            } else {
              if (item.dinner != 3) {
                item.lunch = 0
              }
            }
          }
        }
        return item
      })
      this.checkzou()
      this.$emit('change', this.orderDaysList)
    },

    // 星期几晚餐全選
    handleCheckAllChangethree(val, i) {
      const index = this.weeks.indexOf(val)
      this.orderDaysList = this.orderDaysList.map((item) => {
        if (item.year == this.year && item.month == this.month) {
          if (index == item.week) {
            if (this.checkAllthree[this.year + '-' + this.month][i] == true) {
              if (item.dinner != 3) {
                item.dinner = 1
              }
            } else {
              if (item.dinner != 3) {
                item.dinner = 0
              }
            }
          }
        }
        return item
      })
      this.checkzou()
      this.$emit('change', this.orderDaysList)
    },

    // 判斷左側是否全選
    checkzou() {
      const xbday = this.orderDaysList.filter(item => item.year == this.year && item.month == this.month)
      const xb = Math.max.apply(Math, xbday.map(item => {
        return item.zhou
      }))
      for (let y = 1; y <= xb; y++) {
        const arr = this.orderDaysList.filter((item) => {
          return (
            (item.year == this.year &&
              item.month == this.month &&
              item.zhou == y &&
              (item.dinner == 0 || item.dinner == 3)) ||
            (item.year == this.year &&
              item.month == this.month &&
              item.zhou == y &&
              (item.lunch == 0 || item.lunch == 3)) ||
            (item.year == this.year &&
              item.month == this.month &&
              item.zhou == y &&
              (item.breakfast == 0 || item.breakfast == 3))
          )
        })
        if (arr.length > 0) {
          this.checkAll[this.year + '-' + this.month][y - 1] = false
        } else {
          this.checkAll[this.year + '-' + this.month][y - 1] = true
        }
      }
    },
    // 第幾行全選早午晚餐
    handleCheckAllChange(val, i) {
      this.orderDaysList = this.orderDaysList.map((item) => {
        if (item.year == this.year && item.month == this.month) {
          if (val == item.zhou) {
            if (this.checkAll[this.year + '-' + this.month][i] == true) {
              if (item.breakfast != 3) {
                item.breakfast = 1
              }
              if (item.lunch != 3) {
                item.lunch = 1
              }
              if (item.dinner != 3) {
                item.dinner = 1
              }
            } else {
              if (item.breakfast != 3) {
                item.breakfast = 0
              }
              if (item.lunch != 3) {
                item.lunch = 0
              }
              if (item.dinner != 3) {
                item.dinner = 0
              }
            }
          }
        }
        return item
      })
      this.weeks.forEach((it, index) => {
        const breakfastarr = this.orderDaysList.filter((item) => {
          return (
            item.year == this.year &&
            item.month == this.month &&
            item.week == index &&
            (item.breakfast == 0 || item.breakfast == 3)
          )
        })
        const luncharr = this.orderDaysList.filter((item) => {
          return (
            item.year == this.year &&
            item.month == this.month &&
            item.week == index &&
            (item.lunch == 0 || item.lunch == 3)
          )
        })
        const dinnerarr = this.orderDaysList.filter((item) => {
          return (
            item.year == this.year &&
            item.month == this.month &&
            item.week == index &&
            (item.dinner == 0 || item.dinner == 3))
        })
        if (breakfastarr.length > 0) {
          this.checkAllone[this.year + '-' + this.month][index] = false
        } else {
          this.checkAllone[this.year + '-' + this.month][index] = true
        }
        if (luncharr.length > 0) {
          this.checkAlltwo[this.year + '-' + this.month][index] = false
        } else {
          this.checkAlltwo[this.year + '-' + this.month][index] = true
        }
        if (dinnerarr.length > 0) {
          this.checkAllthree[this.year + '-' + this.month][index] = false
        } else {
          this.checkAllthree[this.year + '-' + this.month][index] = true
        }
        this.zaocheck = this.checkAllone[this.year + '-' + this.month]
        this.wucheck = this.checkAlltwo[this.year + '-' + this.month]
        this.wancheck = this.checkAllthree[this.year + '-' + this.month]
      })
      this.$emit('change', this.orderDaysList)
    },

    // 點擊單個早午晚殘選擇
    chooseEmeal(row, it, index) {
      if (
        this.orderDaysList.find(
          (item) =>
            item.year == row.year &&
            item.month == row.month &&
            item.day == row.day
        )[index == 1 ? 'breakfast' : index == 2 ? 'lunch' : 'dinner'] == 1
      ) {
        this.$set(
          this.orderDaysList.find(
            (item) =>
              item.year == row.year &&
              item.month == row.month &&
              item.day == row.day
          ),
          index == 1 ? 'breakfast' : index == 2 ? 'lunch' : 'dinner',
          0
        )
      } else {
        this.$set(
          this.orderDaysList.find(
            (item) =>
              item.year == row.year &&
              item.month == row.month &&
              item.day == row.day
          ),
          index == 1 ? 'breakfast' : index == 2 ? 'lunch' : 'dinner',
          1
        )
      }
      const arr = this.orderDaysList.filter((item) => {
        return (
          (item.year == this.year &&
            item.month == this.month &&
            item.zhou == it &&
            (item.dinner == 0 || item.dinner == 3)) ||
          (item.year == this.year &&
            item.month == this.month &&
            item.zhou == it &&
            (item.lunch == 0 || item.lunch == 3)) ||
          (item.year == this.year &&
            item.month == this.month &&
            item.zhou == it &&
            (item.breakfast == 0 || item.breakfast == 3))
        )
      })
      const xinqi = this.orderDaysList.find((item) => {
        return (
          item.year == this.year &&
          item.month == this.month &&
          item.zhou == it &&
          item.day == row.day
        )
      }).week
      const weekarr = this.orderDaysList.filter((item) => {
        return (
          item.year == this.year &&
          item.month == this.month &&
          item.week == xinqi &&
          item[index == 1 ? 'breakfast' : index == 2 ? 'lunch' : 'dinner'] == 0 || 3
        )
      })
      if (arr.length > 0) {
        this.checkAll[this.year + '-' + this.month][it - 1] = false
      } else {
        this.checkAll[this.year + '-' + this.month][it - 1] = true
      }
      if (weekarr.length > 0) {
        (index == 1
          ? this.checkAllone
          : index == 2
            ? this.checkAlltwo
            : this.checkAllthree)[this.year + '-' + this.month][xinqi] = false
      } else {
        (index == 1
          ? this.checkAllone
          : index == 2
            ? this.checkAlltwo
            : this.checkAllthree)[this.year + '-' + this.month][xinqi] = true
      }
      this.$emit('change', this.orderDaysList)
    }
  }
}
</script>
<style lang="scss" scoped>
.rili {
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    background: #c6c6c6;
    padding: 10px 30px;
    font-size: 20px;

    p {
      margin: 0 50px;
    }

    i {
      cursor: pointer;
    }
  }

  .zongweek {
    width: 100%;
    overflow-x: auto;

  }

  .weekrow {
    width: 100%;
    display: table;
    // align-items: center;
    border: 1px solid #a3a3a3;
    border-top: none;

    .onecol {
      max-width: 38.72px;
      color: #a3a3a3;
      padding: 10px;
      border-right: 1px solid #a3a3a3;
      writing-mode: vertical-rl;
      text-align: center;
      display: table-cell;

      .pspan {
        display: inline-block;
        width: 18.72px;
      }
    }

    .coltwo {
      text-align: center;
      padding: 10px;
      display: table-cell;



      p {
        margin: 0;
      }

      .xuan {
        display: flex;
        justify-content: center;


        div {
          margin: 20px 0px 0px;
          color: #a3a3a3;
          padding: 5px;
          border: 1px solid #a3a3a3;
          border-radius: 5px;
        }

        div:nth-child(2) {
          margin: 20px 10px 0px 10px;
        }
      }

      .xuan2 {
        display: flex;
        justify-content: center;

        div {
          margin: 40px 0px 0px;
          color: #a3a3a3;
          padding: 5px;
          border: 1px solid #a3a3a3;
          border-radius: 5px;
        }

        div:nth-child(2) {
          margin: 40px 10px 0px 10px;
        }
      }
    }
  }

  .weekrow:first-child {
    .coltwo:nth-child(n+3) {
      padding-left: 11px;
    }
  }
}
</style>
